import { c as _c } from "react/compiler-runtime";
import React from "react";
interface CursorLogoProps {
  className?: string;
  size?: number;
}

/**
 * Cursor IDE logo icon (2D cube) - official Cursor branding
 */
export function CursorLogo(t0) {
  const $ = _c(4);
  const {
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M457.43,125.94L244.42,2.96c-6.84-3.95-15.28-3.95-22.12,0L9.3,125.94c-5.75,3.32-9.3,9.46-9.3,16.11v247.99c0,6.65,3.55,12.79,9.3,16.11l213.01,122.98c6.84,3.95,15.28,3.95,22.12,0l213.01-122.98c5.75-3.32,9.3-9.46,9.3-16.11v-247.99c0-6.65-3.55-12.79-9.3-16.11h-.01ZM444.05,151.99l-205.63,356.16c-1.39,2.4-5.06,1.42-5.06-1.36v-233.21c0-4.66-2.49-8.97-6.53-11.31L24.87,145.67c-2.4-1.39-1.42-5.06,1.36-5.06h411.26c5.84,0,9.49,6.33,6.57,11.39h-.01Z" fill="currentColor" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className || $[2] !== size) {
    t3 = <svg width={size} height={size} viewBox="0 0 466.73 532.09" className={className}>{t2}</svg>;
    $[1] = className;
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}